<template>
  <CHeader id="nav" with-subheader>
    <!-- <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand
      class="mx-auto d-lg-none"
      src="img/brand/coreui-vue-pro-logo.svg"
      width="190"
      height="46"
      alt="CoreUI Logo"
    /> -->
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <div id="image-card" class="col-md-6">
          <div class="align-items-center" v-if="$store.getters.get_company">
            <img v-if="$store.getters.get_company.id == 9" width="40" :src="'https://mybarber.howertpi.com/assets/' + logo" alt="">
            <!-- <img v-if="$store.getters.get_company.id == 10" class="banner-image" :src="'https://mybarber.howertpi.com/assets/' + logo" alt=""> -->
            <img v-else class="banner-image" :src="'https://mybarber.howertpi.com/assets/' + logo" alt="">
          </div>
        </div>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink>
          Bienvenido, <b>{{user}} </b>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink>
          Empresa:<b>&nbsp;{{$store.getters.get_company ? $store.getters.get_company.name : ""}}</b> 
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3" v-if="$store.getters.get_campu != null">
        <CHeaderNavLink>
          Sede: <b>&nbsp;{{$store.getters.get_campu.name}}</b> 
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3" v-if="$store.getters.get_rol != null">
        <CHeaderNavLink>
          Rol: <b>&nbsp;{{$store.getters.get_rol.name}}</b> 
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav>
      <CHeaderNavItem class="px-3">
        <button
          @click="() => $store.commit('toggle', 'darkMode')"
          class="c-header-nav-btn"
        >
          <CIcon v-if="$store.state.darkMode" name="cil-sun"/>
          <CIcon v-else name="cil-moon"/>
        </button>
      </CHeaderNavItem>
      <!-- <TheHeaderDropdownNotif/>
      <TheHeaderDropdownTasks/>
      <TheHeaderDropdownMssgs/> -->
      <TheHeaderDropdownAccnt/>
      <CHeaderNavItem class="px-3">
        <button
          class="c-header-nav-btn"
          @click="$store.commit('toggle', 'asideShow')"
        >
          <CIcon size="lg" name="cil-applications-settings" class="mr-2"/>
        </button>
      </CHeaderNavItem>
    </CHeaderNav>

    <!-- <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0"/>
    </CSubheader> -->
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderDropdownNotif from './TheHeaderDropdownNotif'
import TheHeaderDropdownTasks from './TheHeaderDropdownTasks'
import TheHeaderDropdownMssgs from './TheHeaderDropdownMssgs'
export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderDropdownNotif,
    TheHeaderDropdownTasks,
    TheHeaderDropdownMssgs
  },
  data() {
    return {
      user:"",
      logo:""
    }
  },
  created() {
    this.user = this.$store.getters.get__user_name+" "+this.$store.getters.get_all_user.last_name;
    this.logo = this.$store.getters.get_all_user.id == 1 ? null : this.$store.getters.get_company.logo;
  },
}
</script>
<style scoped>
.banner-image {
  width: 90px;
  height: auto;
  max-height: 100%;
  object-fit: cover;
}

#image-card {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

